import CN from "./CN";
import EN from "./EN";
import DE from "./DE";
import ES from "./ES";
import FR from "./FR";
import IT from "./IT";
import JP from "./JP";
import KR from "./KR";
import PT from "./PT";
import TW from "./TW";
import en from "iview/dist/locale/en-US";
import zh from "iview/dist/locale/zh-CN";
let zhTrans = Object.assign(CN, zh);
let enTrans = Object.assign(EN, en);
export default {
    zh: zhTrans,
    en: enTrans,
    de: DE,
    es: ES,
    fr: FR,
    it: IT,
    jp: JP,
    kr: KR,
    pt: PT,
    tw: TW,
};

// import CN from "./CN"
// import EN from "./EN"
// import enLocale from 'iview/dist/locale/en-US';
// import cnLocale from 'iview/dist/locale/zh-CN';
// const messages = {
//     CN: Object.assign(CN, cnLocale),
//     EN: Object.assign(EN, enLocale)
//   }
// export default messages
